module.exports = __webpack_public_path__ + "img/2D_2.5D.cd63fd89.png";